(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/iam-postmessage/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/iam-postmessage/assets/javascripts/prescript.js');

'use strict';

var _svs, _svs$accountservices, _svs$accountservices$, _svs$accountservices$2;
svs || (svs = {});
(_svs = svs).accountservices || (_svs.accountservices = {});
(_svs$accountservices = svs.accountservices).iamPostMessage || (_svs$accountservices.iamPostMessage = {});
(_svs$accountservices$ = svs.accountservices.iamPostMessage).data || (_svs$accountservices$.data = {});
(_svs$accountservices$2 = svs.accountservices.iamPostMessage.data).config || (_svs$accountservices$2.config = {});
svs.accountservices.iamPostMessage.logger = svs.core.log.getLogger('accountservices:iam-postmessage');

 })(window);